import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cz-jl",
  "use": "icon-cz-jl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cz-jl\"><path d=\"M879.5 320v462.3l-32 53.3-32-53.3V320h64m64-64h-192v544l96 160 96-160V256zM943.5 64h-192v128h192V64zM655.5 287h-543c-17.7 0-32-14.3-32-32s14.3-32 32-32h543c17.7 0 32 14.3 32 32s-14.3 32-32 32zM534.8 544H112.5c-17.7 0-32-14.3-32-32s14.3-32 32-32h422.3c17.7 0 32 14.3 32 32s-14.3 32-32 32zM474.5 799h-362c-17.7 0-32-14.3-32-32s14.3-32 32-32h362c17.7 0 32 14.3 32 32s-14.3 32-32 32z\" fill=\"#e6e6e6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cz-jl.svg
// module id = jj/3
// module chunks = 77